export const LOT_STATUS_COLORS = {
  ACTIVE: 'success',
  EXPIRING: 'warning',
  EXPIRED: 'error',
  DEPLETED: 'default'
};

export const formatLotNumber = (value) => (value ?? 0).toLocaleString('es-UY', { maximumFractionDigits: 3 });
